import { render, staticRenderFns } from "./TableControls.vue?vue&type=template&id=03671599"
import script from "./TableControls.vue?vue&type=script&lang=js"
export * from "./TableControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports